export const fetchUserProfile = async (token, base_url, setUser, setCompany) => {
    if (!token) return null;
    
    try {
        const response = await fetch(`${base_url}/core/users/get-profile`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': token
            }
        });
        
        const data = await response.json();
        console.log(data);
        setUser(data.user);
        setCompany(data.company);
    } catch (error) {
        console.error('Error fetching user:', error);
        throw error;
    }
}; 